<mode-quill-editor
  *ngIf="editable"
  [description]="description"
  [showTextLimitWarning]="showTextLimitWarning"
  (checkForTextLimit)="checkForTextLimit($event)"
  (sendFieldDescription)="sendFieldDescription($event)"
  (showWarning)="showWarning($event)"
  data-test="field-description-editor"
></mode-quill-editor>
<mode-field-description-view
  *ngIf="!editable"
  [description]="description"
  [readOnly]="readOnly"
  (toggleEditable)="toggleEditable()"
  data-test="field-description-view"
></mode-field-description-view>
<div>
  <p class="warning-notice" *ngIf="showTextLimitWarning" data-test="warning-notice">
    Description must be between 0-350 characters
  </p>
</div>
